module.exports = __webpack_public_path__ + "img/diagonal-arrow.91060b43.svg";